import type { DoraRisk } from './doraRisk.ts';
import type { DoraIncident } from './doraIncident.ts';
import type { DoraTestingExercise } from './doraTestingExercise.ts';
import type { DoraControl } from './doraControl.ts';

export interface DoraFinding {
  id?: number;
  title: string;
  description?: string | null;
  created_at: string;
  status: string;
  risk_id?: number | null;
  incident_id?: number | null;
  testing_exercise_id?: number | null;
  control_id?: number | null;
  risk?: DoraRisk | null;
  incident?: DoraIncident | null;
  testing_exercise?: DoraTestingExercise | null;
  control?: DoraControl | null;
}

export type DoraFindingUpdate = Partial<Omit<DoraFinding,
  'id' |
  'risk' |
  'incident' |
  'testing_exercise' |
  'control'
>>;

export const doraFindingToUpdate = ({
  id,
  risk,
  incident,
  testing_exercise,
  control,
  ...rest
}: DoraFinding): DoraFindingUpdate => ({
  ...rest,
});
